import { render, staticRenderFns } from "./WeeklyPlan.vue?vue&type=template&id=1d507442&scoped=true"
import script from "./WeeklyPlan.vue?vue&type=script&lang=js"
export * from "./WeeklyPlan.vue?vue&type=script&lang=js"
import style0 from "./WeeklyPlan.vue?vue&type=style&index=0&id=1d507442&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d507442",
  null
  
)

export default component.exports